import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* fetch_charge_types() {
    yield* takeEvery("CHARGE_TYPES/FETCH", function* (action) {
        try {
            const result = yield call(({ idProperty }) => {
                return request.get(`${config.apiEndpoint}/api/v4/settings/charge_types/${idProperty}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'CHARGE_TYPES/SET', charge_types: result.charge_types });
            }
        } catch (e) {
            yield put({ type: 'CHARGE_TYPES/FETCH_FAILED', e });
        }
    });
}

export function* create_charge_type() {
    yield* takeEvery("CHARGE_TYPE/CREATE", function* (action) {
        try {
            const result = yield call(({ idProperty, name }) => {
                return request.post(`${config.apiEndpoint}/api/v4/settings/charge_types`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .send({ IdProperty: idProperty, Name: name })
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'CHARGE_TYPES/FETCH', idProperty: action.idProperty });
            }
        } catch (e) { }
    });
}

export function* update_charge_type() {
    yield* takeEvery("CHARGE_TYPE/UPDATE", function* (action) {
        try {
            const result = yield call(({ id, name }) => {
                return request.patch(`${config.apiEndpoint}/api/v4/settings/charge_types/${id}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .send({ Name: name })
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'CHARGE_TYPES/FETCH', idProperty: action.idProperty });
            }
        } catch (e) { }
    });
}

export function* delete_charge_type() {
    yield* takeEvery("CHARGE_TYPE/DELETE", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.delete(`${config.apiEndpoint}/api/v4/settings/charge_types/${id}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'CHARGE_TYPES/FETCH', idProperty: action.idProperty });
            }
        } catch (e) { }
    });
}

// Rate Types

export function* fetch_rate_types() {
    yield* takeEvery("RATE_TYPES/FETCH", function* (action) {
        try {
            const result = yield call(({ idProperty }) => {
                return request.get(`${config.apiEndpoint}/api/v4/settings/rate_types/${idProperty}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'RATE_TYPES/SET', rate_types: result.rate_types });
            }
        } catch (e) {
            yield put({ type: 'RATE_TYPES/FETCH_FAILED', e });
        }
    });
}

export function* create_rate_type() {
    yield* takeEvery("RATE_TYPE/CREATE", function* (action) {
        try {
            const result = yield call(({ idProperty, name, code }) => {
                return request.post(`${config.apiEndpoint}/api/v4/settings/rate_types`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .send({ IdProperty: idProperty, Name: name, Code: code })
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'RATE_TYPES/FETCH', idProperty: action.idProperty });
            }
        } catch (e) { }
    });
}

export function* update_rate_type() {
    yield* takeEvery("RATE_TYPE/UPDATE", function* (action) {
        try {
            const result = yield call(({ id, name }) => {
                return request.patch(`${config.apiEndpoint}/api/v4/settings/rate_types/${id}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .send({ Name: name })
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'RATE_TYPES/FETCH', idProperty: action.idProperty });
            }
        } catch (e) { }
    });
}

export function* delete_rate_type() {
    yield* takeEvery("RATE_TYPE/DELETE", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.delete(`${config.apiEndpoint}/api/v4/settings/rate_types/${id}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => JSON.parse(data.text));
            }, action);
            if (result && result.success) {
                yield put({ type: 'RATE_TYPES/FETCH', idProperty: action.idProperty });
            }
        } catch (e) { }
    });
}
